export const REMINDERS_SETTING_KEY = 'lichNhac';
/** Thứ 2 – Thứ 7: số liệu báo cáo công việc cho thấy công ty không làm Chủ nhật. */
const WORK_DAYS = [0, 1, 2, 3, 4, 5];
export const DEFAULT_REMINDERS = [
    {
        id: 'bao-cao',
        time: '09:30',
        title: 'Báo cáo công việc trong ngày',
        body: 'Đã 9h30 — làm báo cáo công việc trong ngày.',
        days: WORK_DAYS,
        url: '/work-reports',
        enabled: true,
    },
    {
        // Mở thẳng tab «Nhập chỉ số» của SEO kênh — màn ai cũng vào được; «Nhập doanh thu» thì theo quyền.
        id: 'chi-so-doanh-thu',
        time: '10:00',
        title: 'Điền chỉ số và doanh thu',
        body: 'Đã 10h00 — điền chỉ số và doanh thu.',
        days: WORK_DAYS,
        url: '/seo/entry',
        enabled: true,
    },
];
export const REMINDER_LIMITS = { count: 12, title: 60, body: 160, url: 200 };
/** Máy chủ vừa khởi động lại đúng lúc tới giờ thì vẫn bắn bù; trễ quá ngần này thì thôi — nhắc muộn là nhiễu. */
export const REMINDER_GRACE_MINUTES = 30;
/** Mã lịch nhắc: chữ thường, số, gạch ngang; tối đa 32 ký tự (cũng là nhãn `Topic` của Web Push). */
const REMINDER_ID = /^[a-z0-9-]{1,32}$/;
/** «HH:MM» → số phút từ đầu ngày; `null` khi không phải giờ hợp lệ. */
export function reminderMinutes(time) {
    const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(time);
    return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}
/** Đường dẫn trong app: bắt đầu bằng một dấu «/» (không cho «//» — đó là địa chỉ ngoài). */
const isAppPath = (url) => url.startsWith('/') && !url.startsWith('//');
/** Lý do một lịch nhắc chưa dùng được, hoặc `null`. Dùng cho cả ô nhập ở Cài đặt lẫn lúc đọc dữ liệu. */
export function findReminderProblem(reminder) {
    if (!REMINDER_ID.test(reminder.id))
        return 'Mã lịch nhắc không hợp lệ';
    if (reminderMinutes(reminder.time) === null)
        return 'Giờ nhắc phải theo dạng HH:MM';
    if (!reminder.title.trim())
        return 'Chưa có tiêu đề';
    if (reminder.title.length > REMINDER_LIMITS.title)
        return 'Tiêu đề quá dài';
    if (reminder.body.length > REMINDER_LIMITS.body)
        return 'Nội dung quá dài';
    if (!reminder.days.length)
        return 'Chưa chọn ngày nào trong tuần';
    if (!isAppPath(reminder.url) || reminder.url.length > REMINDER_LIMITS.url) {
        return 'Màn hình mở ra phải là một đường dẫn trong app';
    }
    return null;
}
function readReminder(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return null;
    const raw = value;
    const text = (field) => (typeof field === 'string' ? field.trim() : '');
    const days = Array.isArray(raw.days)
        ? [...new Set(raw.days.filter((d) => Number.isInteger(d) && d >= 0 && d <= 6))]
        : [];
    const reminder = {
        id: text(raw.id),
        time: text(raw.time),
        title: text(raw.title),
        body: text(raw.body),
        days: days.sort((a, b) => a - b),
        url: text(raw.url) || '/',
        // Chỉ `false` tường minh mới là tắt.
        enabled: raw.enabled !== false,
    };
    return findReminderProblem(reminder) ? null : reminder;
}
/** Đọc khoá `lichNhac` của bản ghi cài đặt. Dòng hỏng thì bỏ; trùng mã thì giữ dòng đầu. */
export function readReminders(value) {
    if (!Array.isArray(value))
        return DEFAULT_REMINDERS.map((item) => ({ ...item, days: [...item.days] }));
    const seen = new Set();
    const reminders = [];
    for (const item of value) {
        const reminder = readReminder(item);
        if (!reminder || seen.has(reminder.id))
            continue;
        seen.add(reminder.id);
        reminders.push(reminder);
        if (reminders.length >= REMINDER_LIMITS.count)
            break;
    }
    return reminders;
}
/**
 * Lịch TỚI GIỜ BẮN tại một thời điểm (giờ Việt Nam): đang bật, đúng thứ, đã tới giờ nhưng chưa quá
 * `graceMinutes`, và hôm nay chưa bắn (`alreadySent` là các mã đã bắn trong ngày).
 */
export function dueReminders(reminders, weekday, minutes, alreadySent, graceMinutes = REMINDER_GRACE_MINUTES) {
    return reminders.filter((reminder) => {
        if (!reminder.enabled || alreadySent.has(reminder.id))
            return false;
        if (!reminder.days.includes(weekday))
            return false;
        const at = reminderMinutes(reminder.time);
        return at !== null && minutes >= at && minutes - at <= graceMinutes;
    });
}
//# sourceMappingURL=reminders.js.map